import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'

import UpgradeSubscriptionFlow from 'components/UpgradeSubscriptionFlow/UpgradeSubscriptionFlow'
import Modal from 'components/modal/Modal/Modal'


export default class QueueUpgradeModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.QueueUpgrade,
  }

  componentDidMount() {
    actions.models.upgradeSubscriptionFlow.fetchPlans()
  }

  close = () => {
    const { name } = this.props

    actions.models.upgradeSubscriptionFlow.setCurrStep(constants.upgradeSubscriptionFlowSteps.selectPlan)
    actions.models.modals.close(name)
  }

  render() {
    const { name } = this.props

    const placement = 'queue popup'

    return (
      <Modal name={name} onClose={this.close}>
        <UpgradeSubscriptionFlow monthPlan={1} placement={placement} onClose={this.close} />
      </Modal>
    )
  }
}
